import { render, staticRenderFns } from "./RowCharity.vue?vue&type=template&id=ca386a1e"
import script from "./RowCharity.vue?vue&type=script&lang=js"
export * from "./RowCharity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports